/*
 *  Osano Cookie Policy
 *  CSS & Javascript Implementation Included
 * 
*/

import { elem } from "../elem/elem.js";

export function cookiePolicy() {

};